import { useCallback } from 'react';
import { App } from 'antd';

import { openExportWindow } from '~library/print';

import useTrackDiagnosticsEvent from './useTrackDiagnosticsEvent';

type ExportTrigger = 'report_page' | 'report_table';

export default function useExportReport() {
  const { notification } = App.useApp();
  const trackDiagnosticsEvent = useTrackDiagnosticsEvent();

  return useCallback(
    (reportId: string, trigger: ExportTrigger) => {
      const win = openExportWindow(`/ai-insights/diagnostics/report/${reportId}/export`);
      if (!win) {
        notification.error({
          message: 'Export blocked',
          description: 'Please allow popups for this site and try again.',
        });
      }
      trackDiagnosticsEvent('Diagnostics: Report Exported', {
        report_id: reportId,
        trigger,
      });
    },
    [notification, trackDiagnosticsEvent],
  );
}
